export default __webpack_public_path__ + "static/media/lioness.93c669ca.png";